import type { Dispatch as ReduxDispatch } from '@reduxjs/toolkit';
import type { Conversation, Message, MessagePayload } from '../@types/Conversation';
import type { BaseAction } from '../@types/actions';
import * as http from '../Http';
import { buildAuthorizedPostRequest } from '../Http/requestTemplates';
import type { RootState } from '../reducers';
import requestCache from '../utils/request-cache';

export const REQ_CREATE_MESSAGE = 'REQ/CREATE_MESSAGE';
export const RCV_CREATE_MESSAGE = 'RCV/CREATE_MESSAGE';
export const REQUEST_FAILED = 'MESSAGE/REQUEST_FAILED';
type REQ_CREATE_MESSAGE_TYPE = BaseAction<typeof REQ_CREATE_MESSAGE>;
type RCV_CREATE_MESSAGE_TYPE = BaseAction<typeof RCV_CREATE_MESSAGE> & {
  response: Message;
};
type REQUEST_FAILED_TYPE = BaseAction<typeof REQUEST_FAILED>;

export type MESSAGE_ACTION =
  | REQ_CREATE_MESSAGE_TYPE
  | RCV_CREATE_MESSAGE_TYPE
  | REQUEST_FAILED_TYPE;

type Dispatch = ReduxDispatch<MESSAGE_ACTION>;

export const create =
  (conversation: Conversation, message: MessagePayload) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const cacheKey = `${REQ_CREATE_MESSAGE}/${conversation.id}`;
    const { auth } = getState();
    if (!auth.token || requestCache.isPending(cacheKey)) {
      return;
    }
    requestCache.isPending(cacheKey, true);

    try {
      dispatch({ type: REQ_CREATE_MESSAGE });

      const response = await http.json<Message>(
        `/api/conversations/${conversation.id}`,
        buildAuthorizedPostRequest(auth.token, { content: message }),
      );
      http.validateResponse(response);
      dispatch({
        type: RCV_CREATE_MESSAGE,
        response: response.response,
      });
    } catch (_e) {
      dispatch({ type: REQUEST_FAILED, action: REQ_CREATE_MESSAGE });
    }
    requestCache.isPending(cacheKey, false);
  };
